module.exports = __webpack_public_path__ + "static/img/hb1.28a504c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hb1.png
// module id = 312u
// module chunks = 0